<template>
  <div>
    <template v-if="doesExist">
      <controls @filter="filter" @export="exp" />
      <cont ref="content"/>
    </template>
  </div>
</template>

<script>
import Controls from '@/components/Controls/index.vue';
import Cont from './Content.vue';

export default {
  components: { Cont, Controls },
  computed: {
    entities() {
      return this.$store.getters.entities;
    },
    entity() {
      return this.$route.params.name;
    },
    hasLoaded() {
      return !!Object.keys(this.entities).length;
    },
    doesExist() {
      return Object.keys(this.entities).includes(this.entity);
    },
  },
  methods: {
    filter(e) {
      if (this.$refs.content) {
        this.$refs.content.handleFilter(e);
      } else {
        this.$nextTick(() => {
          this.$refs.content.handleFilter(e);
        });
      }
    },
    exp() {
      if (this.$refs.content) {
        this.$refs.content.exportData();
      }
    },
    validate() {
      if (!this.hasLoaded) {
        return;
      }

      if (!this.doesExist) {
        this.$router.push(`/entity/${Object.keys(this.entities)[0]}`);
        return;
      }

      this.$store.commit('setCurrentEntity', this.entity);
    },
  },
  watch: {
    entity() {
      this.validate();
    },
    hasLoaded() {
      this.validate();
    },
  },
  created() {
    this.validate();
  },
};
</script>
